
import { defineComponent, computed, inject } from 'vue';
import { useVModel } from 'vue-composable';
import { ChevronForward as ChevronRight, ChevronBack as ChevronLeft } from '@vicons/ionicons5';
import { ShowToast } from '@/providers/Toast/toast-types';

export default defineComponent({
  name: 'SurveyButtons',
  components: { ChevronRight, ChevronLeft },
  emits: ['backClick', 'continueClick', 'finishClick'],
  props: {
    backButton: {
      type: Boolean,
      default: true
    },
    continueButton: {
      type: Boolean,
      default: true
    },
    finishButton: {
      type: Boolean,
      default: false
    },
    hasAgreed: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const backButtonRef = useVModel(props, 'backButton');
    const continueButtonRef = useVModel(props, 'continueButton');
    const finishButtonRef = useVModel(props, 'finishButton');
    const hasAgreedRef = computed(() => props.hasAgreed);
    const showToast = inject<ShowToast>('showToast')!;

    const handlePreviousClick = () => {
      emit('backClick');
    };

    const handleContinueClick = () => {
      if (!hasAgreedRef.value) {
        showToast({
          headline: 'Error',
          message: 'You must agree to participate to continue',
          color: 'danger'
        });
        return;
      }
      emit('continueClick');
    };

    const handleFinishClick = () => {
      if (!hasAgreedRef.value) {
        showToast({
          headline: 'Error',
          message: 'You must agree to participate to continue',
          color: 'danger'
        });
        return;
      }
      emit('finishClick');
    };

    return {
      handleContinueClick,
      handlePreviousClick,
      handleFinishClick,
      backButtonRef,
      continueButtonRef,
      finishButtonRef,
      hasAgreedRef
    };
  }
});
